import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { querySaga } from '../../../utils/reduxHelper';

function* resetIntOutBoundFileSaga() {
    yield put(appActions.INTOUTBOUNDFILE_RESET_SUCCESS());
}

function* watchIntOutBoundFileGetAllRequest() {
    yield takeLatest(
        appActions.INTOUTBOUNDFILE_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                'integration/outboundfile',
                appActions.INTOUTBOUNDFILE_GET_ALL_SUCCESS,
                appActions.INTOUTBOUNDFILE_GET_ALL_FAILURE,
            );
        },
    );
}
export default function* intOutBoundFileWatcher() {
    yield* watchIntOutBoundFileGetAllRequest();
    yield takeLatest(appActions.INTOUTBOUNDFILE_RESET_REQUEST.type, resetIntOutBoundFileSaga);
    // Add other watchers here
}